import { NetworkErrorId, logger, getOptions } from '@sheerid/jslib';

const defaultJsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

export const fetchWithTimeout = (url: string, options = {}) => {
    const timeout = getOptions().httpRequestTimeout;

    return new Promise<Response>((resolve, reject) => {
        const timeoutTimer = setTimeout(() => {
            const networkErrorId: NetworkErrorId = 'requestTimeout';

            reject(new Error(networkErrorId));
        }, timeout);

        return fetch(url, options).then(resolve, (error) => {
            logger.error(`Failed to fetch ${url}`, error);
            const networkErrorId: NetworkErrorId = 'failedToFetch';

            reject(new Error(networkErrorId));
        })
        .finally(() => {
            clearTimeout(timeoutTimer);
        });
    });
};


export const GetJson = async (url: string, headers = defaultJsonHeaders): Promise<Object> => {
    const response = await fetchWithTimeout(url, {
        headers,
        method: 'GET',
    });
    return await processResponse(response);
};

const processResponse = async (response: Response): Promise<Object> => {
    let responseData: Promise<Object>;
    try {
        responseData = await response.json();
    } catch (error) {
        // Handle 204 response
        responseData = Promise.resolve({});
    } finally {
        logger.info('Response received', responseData);
    }
    return responseData;
};
